import { ACDSessionManager } from '@nice-devone/core-sdk';
import { logger } from '../../../utils/logger';

export function persistSessionId(acdSession: ACDSessionManager, sessionId?: string): void {
  if (sessionId) {
    logger.debug('[CXone SDK] Setting session ID:', sessionId);
    acdSession.setSessionId(sessionId);
    localStorage.setItem('acd_session_id', sessionId);
    return;
  }

  const internalSessionId = acdSession.getSessionId();
  logger.debug('[CXone SDK] Session ID from SDK:', internalSessionId);
  if (internalSessionId) {
    localStorage.setItem('acd_session_id', internalSessionId);
  }
}

export function extractSessionId(response: unknown): string | undefined {
  const body = (response as { body?: { sessionId?: string } })?.body;
  return body?.sessionId || (response as { sessionId?: string })?.sessionId;
}

export function clearStaleSession(acdSession: ACDSessionManager): void {
  localStorage.removeItem('acd_session_id');
  acdSession.setSessionId('');
}
